import React from 'react';
import '../../assets/css/fail.css';
import { HashLink as Link } from 'react-router-hash-link';
import Info from './Info';
import Header from '../Header'


//images
import sadInstructorImage from '../../assets/images/fail/sad-instructor.png';
import brand from '../../assets/images/header/brand-white.png';

function Fail(props) {
    return (
        <>
            <Header style={{
                position: 'absolute',
                zIndex: '99',
                marginTop: '100px',
                width: '100%'
            }} />
            <main>
                <section id="fail" style={{
                    paddingTop: '150px'
                }}>
                    <div className="wrapper">
                        {/* <Link to="/" className="brand">
                            <img src={brand} alt="brand" />
                            <h2>
                                Авто Обучение
                            <span>
                                    Цялостно обучение за кандидат-шофьори
                            </span>
                            </h2>
                        </Link> */}

                        <Info {...props} />
                    </div>
                    <div className="car-wrapper">
                        <img src={sadInstructorImage} alt="teacher" />
                    </div>
                </section>
            </main >
        </>
    );
}

export default Fail;
